import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Flex,
  Image,
  Row,
  Typography,
} from "antd";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import Meta from "antd/es/card/Meta";
import { HealthCareCardProps } from "../../props/HealthCareProps";
const { Text } = Typography;

const HealthCareCard: FC<HealthCareCardProps> = ({
  id,
  healthCareList,
  handleNavigate,
}) => {
  return (
    <Badge.Ribbon
      text={
        healthCareList[id].nabhStatus === "ACTIVE"
          ? "ACTIVE"
          : "INACTIVE"
      }
      color={healthCareList[id].nabhStatus === "ACTIVE" ? "blue" : "red"}
    >
      <Card
        style={{
          boxShadow:
            "0 1px 2px -2px rgba(0, 0, 0, 0.8), 0 3px 6px 0 rgba(0, 0, 0, 0.06), 0 5px 12px 4px rgba(0, 0, 0, 0.04)",
          marginTop: 16,
        }}
        hoverable
        actions={[
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={24} lg={24}>
              <Button
                className="health_care_btn"
                onClick={(e) => {
                  e.stopPropagation();
                  // changeSelectedPatient(patientList[id]);
                  handleNavigate(`${ROUTES.HEALTHCARE_DETAILS}/${id}`);
                }}
              >
                VIEW DETAILS
              </Button>
            </Col>
            {/* <Col xs={24} sm={12} lg={12}>
              <Button
                className="health_care_btn"
                onClick={(e) => {
                  e.stopPropagation();
                  // changeSelectedPatient(patientList[id]);
                  // handleNavigate(`${ROUTES.PATIENT_DETAILS}/${id}`);
                }}
              >
                Edit Health Care
              </Button>
            </Col> */}
          </Row>,
        ]}
      >
        <Row style={{ marginBottom: "1rem" }}>
          <Flex gap="large">
            <Image
              width={100}
              height={50}
              preview={false}
              src={healthCareList[id].logoUrl || ""}
              alt="-Logo N/A"
            />
            <Flex align="center">
              <Text strong style={{ fontSize: "1.2rem" }}>
                {healthCareList[id].name?.toUpperCase()}
              </Text>
            </Flex>
          </Flex>
        </Row>

        <Meta
          style={{ marginTop: 6 }}
          description={
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12} lg={8}>
                <Text strong>PHONE:</Text>{" "}
                {healthCareList[id].primaryPhone?.toUpperCase()}
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Text strong>EMAIL:</Text>{" "}
                {healthCareList[id].email?.toUpperCase()}
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Text strong>ADDRESS:</Text>{" "}
                {healthCareList[id].city?.toUpperCase()}{" "}
                {healthCareList[id].state?.toUpperCase()}{" "}
                {healthCareList[id].country?.toUpperCase()}
              </Col>
            </Row>
          }
        />
      </Card>
    </Badge.Ribbon>
  );
};

export default HealthCareCard;
